export const GENRE_CHIP_FALLBACK_BG = 'var(--genre-chip-fallback-bg)';
export const GENRE_CHIP_FALLBACK_TEXT = 'var(--genre-chip-fallback-text)';

export const normalizeGenresPayload = (payload) => {
  if (Array.isArray(payload)) return payload;

  if (payload && typeof payload === 'object') {
    if (Array.isArray(payload.genres)) return payload.genres;
    if (Array.isArray(payload.data)) return payload.data;
    if (Array.isArray(payload.items)) return payload.items;
    if (payload.data && typeof payload.data === 'object' && Array.isArray(payload.data.genres)) {
      return payload.data.genres;
    }
  }

  return [];
};
